import { ApiClient, CurrencyRecommendationModel, SubscriptionPlanFullPricingModel } from "../generated/api";
import CONFIG_KEYS from "../config";
import { customFetch } from "../middlewares/custom-fetch";
 

export class SubscriptionService {

    private api: ApiClient;

    constructor(navigate?: (url: string) => void) {
        this.api = new ApiClient(CONFIG_KEYS.baseUrl, { fetch: customFetch });
    }

    // Fetched directly (not via the generated client) so plan-limit fields the
    // generated model doesn't yet know about — maxCourses / maxStudents /
    // maxLectures — aren't stripped out before they reach the plan card.
    public async LoadFullSubscriptionPlansList(): Promise<SubscriptionPlanFullPricingModel[]> {
        const res = await this.api.subscriptionPlansFullList();
        return res;
    }

    /**
     * Public (no-login) pricing for the /pricing page — returns BOTH tutor and academy
     * tiers in the requested currency (server falls back to USD per plan when missing).
     * Fetched directly so it works for anonymous visitors and keeps the plan-limit fields.
     */
    public async getPublicPricing(currencyCode?: string): Promise<SubscriptionPlanFullPricingModel[]> {
        const query = currencyCode ? `?currencyCode=${encodeURIComponent(currencyCode)}` : "";
        const res = await customFetch(`${CONFIG_KEYS.baseUrl}/api/Subscription/PublicPricing${query}`, { method: "GET" });
        return await res.json();
    }

    /**
     * Returns the recommended PayPal-compatible currency for a given country code.
     * Falls back to USD if the country is not found or its currency is not PayPal-supported.
     */
    public async getCurrencyForCountry(countryCode: string): Promise<CurrencyRecommendationModel> {
        try {
            const res = await this.api.currencyForCountry(countryCode);
            return res;
        } catch {
            return { currencyCode: "USD", currencyName: "United States Dollar", symbol: "$", supportPayPal: true };
        }
    }
}
